import { render, staticRenderFns } from "./OverviewUnits.vue?vue&type=template&id=016498ee"
import script from "./OverviewUnits.vue?vue&type=script&lang=js"
export * from "./OverviewUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports